export default "__VITE_ASSET__Kq1dTjIY__"